module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gray-back kaoji-box",
    staticStyle: {
      "padding": ".2rem 0 1rem 0",
      "height": "100%"
    }
  }, [_c('van-cell-group', [_c('van-cell', {
    attrs: {
      "title": "单位名称",
      "value": _vm.row.danwei
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "title": "所属区域",
      "value": _vm.areaValue
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "title": "先进个人",
      "value": _vm.row.jiaoshi_name
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "title": "证书编号",
      "value": _vm.row.bcode ? _vm.row.bcode : '无'
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "title": "线下领取牌匾的比赛名称",
      "value": _vm.row.saiqu_name ? _vm.row.saiqu_name : '无'
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "title": "推广实施单位电子授权书"
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isLoading),
      expression: "!isLoading"
    }],
    staticClass: "bottom-img"
  }, [_c('img', {
    attrs: {
      "src": _vm.row.danwei_pic,
      "alt": ""
    }
  }), _vm._v(" "), (!_vm.isApp) ? _c('van-button', {
    staticStyle: {
      "margin": "10px auto",
      "text-align": "center"
    },
    attrs: {
      "type": "default",
      "round": ""
    }
  }, [_vm._v("请长按图片保存")]) : _c('van-button', {
    staticStyle: {
      "margin": "10px auto",
      "text-align": "center"
    },
    attrs: {
      "type": "default",
      "round": ""
    },
    on: {
      "click": _vm.onPrint
    }
  }, [_vm._v("点击下载证书")])], 1), _vm._v(" "), _c('van-cell', {
    attrs: {
      "title": "先进个人电子授权书"
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isLoading),
      expression: "!isLoading"
    }],
    staticClass: "bottom-img"
  }, [_c('img', {
    attrs: {
      "src": _vm.row.person_pic,
      "alt": ""
    }
  }), _vm._v(" "), (!_vm.isApp) ? _c('van-button', {
    staticStyle: {
      "margin": "10px auto",
      "text-align": "center"
    },
    attrs: {
      "type": "default",
      "round": ""
    }
  }, [_vm._v("请长按图片保存")]) : _c('van-button', {
    staticStyle: {
      "margin": "10px auto",
      "text-align": "center"
    },
    attrs: {
      "type": "default",
      "round": ""
    },
    on: {
      "click": _vm.onPrintPerson
    }
  }, [_vm._v("点击下载证书")])], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "10px"
    }
  })], 1), _vm._v(" "), _c('LoginDialog', {
    attrs: {
      "show": _vm.loginShow
    },
    on: {
      "loginSuccess": _vm.loginSuccess,
      "loginCancel": _vm.loginCancel
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fbe4b786","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/apps/cdakejian/DakejianDetail.vue
// module id = 2619
// module chunks = 0